<template>
  <div>
    <component :is="componentByType" v-bind="$attrs" :size="size"></component>
    <slot name="message" v-bind:message="message">
      <div v-if="message">
        <h1>{{ message }}</h1>
      </div>
    </slot>
  </div>
</template>
<script>
const SPINNER_TYPE = {
    CUBESHADOW: ()=>import("@/redworks/components/spinners/CubeShadow.vue"),
};
export default {
  props: {
    message: {
      type: String,
      default: "로딩중",
    },
    size: {
      default: "40px",
    },
    spinnerType: {
      type: String,
      default: "CUBESHADOW",
    },
  },
  computed: {
    styles() {
      return {
        width: this.size,
        height: this.size,
      };
    },
    componentByType() {
       return SPINNER_TYPE[this.spinnerType];
    }
  },
};
</script>
